/**
 * preorder-labels.js
 *
 * Updates variant dropdown labels from "Sold out" → "Pre-order" for variants
 * that the PreOrder Globo app has configured as pre-orderable.
 *
 * Reads from window.GloboPreorderParams.preorderSettings.products, which Globo
 * injects directly into the page as a JS global (no network request needed).
 * Structure: { [productId]: { [variantId]: profileId } }
 */

(function () {
  'use strict';

  const preorderIds = new Set();

  // -------------------------------------------------------------------------
  // Build a Set of all pre-order variant IDs from Globo's global config.
  // We iterate all products so we don't need to know the current product ID.
  // -------------------------------------------------------------------------
  function loadPreorderIds() {
    const products = window.GloboPreorderParams?.preorderSettings?.products;
    if (!products) return false;

    for (const variantMap of Object.values(products)) {
      for (const variantId of Object.keys(variantMap)) {
        preorderIds.add(variantId);
      }
    }
    return true;
  }

  // -------------------------------------------------------------------------
  // Patch any [data-preorder-variant-id] span whose variant ID is in our set.
  // Called on init AND after each variant:change re-render.
  // -------------------------------------------------------------------------
  function applyLabels() {
    if (preorderIds.size === 0) return;

    document.querySelectorAll('[data-preorder-variant-id]').forEach((span) => {
      if (preorderIds.has(span.dataset.preorderVariantId)) {
        span.textContent = 'Pre-order';
      }
    });
  }

  // -------------------------------------------------------------------------
  // Init: try immediately, then retry up to ~2s if Globo hasn't loaded yet.
  // -------------------------------------------------------------------------
  function init(attempts) {
    if (loadPreorderIds()) {
      applyLabels();
    } else if (attempts > 0) {
      setTimeout(function () { init(attempts - 1); }, 100);
    }
  }

  // Run once the DOM is ready (script is deferred, so DOM is already parsed,
  // but Globo may finish its own deferred init slightly later).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(20); });
  } else {
    init(20);
  }

  // Re-apply labels every time the theme re-renders the variant picker
  // (the theme fires variant:change on the form after each AJAX re-render).
  document.addEventListener('variant:change', function () {
    requestAnimationFrame(applyLabels);
  }, true);
})();
